//Custo css import (removed as it's now shared in ServiceForm)
//Boostrap import

//React import
import React from 'react';
import { Wrench } from 'lucide-react';

//Controller import
import ModalBtn from '../../molecules/modalButton/view';
import { createService } from '../../../usecases/service-usecase';
import { dispatchCustomEvent } from '../../../utils/dispatch';
import { mapServiceToApi } from '../../../infrastructure/mappers/service-mapper';
import ServiceForm from '../ServiceForm/view';

function NewService({ id, profile }) {
    const submitId = "service-create";

    const handleOpen = () => {
        // En el nuevo diseño, la lógica de inicialización está dentro de ServiceForm
    };

    const onSubmit = (formData) => {
        const payload = mapServiceToApi(formData, 'create');
        createService(payload).then((res) => {
            dispatchCustomEvent("close-newService-" + id + "-modal", []);
            dispatchCustomEvent("popup", { message: "Servicio creado correctamente", type: "success" });
            dispatchCustomEvent("reload-services", res);
            dispatchCustomEvent("loading-btn-" + submitId, null);
        }).catch((error) => {
            dispatchCustomEvent("loading-btn-" + submitId, null);
            const err = error.response?.data?.message;
            const messages = {
                "limit_reached": "Ups, alcanzaste tu límite de servicios, aumenta tu plan y remueve todos los límites...",
                "service_exist": "Existe un servicio con el mismo SKU.",
                "sku_empty": "El SKU no puede estar vacío.",
                "name_empty": "El nombre no puede estar vacío.",
                "value_empty": "El valor del servicio no puede estar vacío.",
                "value_invalid": "Valor del servicio no válido.",
            };

            if (error.response?.data === 'reached limit') {
                dispatchCustomEvent("popup", { message: "Límite alcanzado", type: "error" });
            } else if (err && messages[err]) {
                dispatchCustomEvent("popup", { message: messages[err], type: "error" });
            } else {
                dispatchCustomEvent("popup", { message: "Ocurrió un error al crear el servicio", type: "error" });
            }
        });
    };

    return (
        <ModalBtn
            id={"newService-" + id}
            title="Nuevo Servicio"
            icon={<Wrench size={20} />}
            onClick={handleOpen}
        >
            <ServiceForm
                mode="create"
                onSubmit={onSubmit}
                submitId={submitId}
            />
        </ModalBtn>
    );
}

export default NewService
